document.addEventListener('DOMContentLoaded', function() {
    const addToCartBtn = document.querySelector('form[action="/cart/add"] [type="submit"]');
    const productForm = addToCartBtn.closest('form');

    // Create loader/message container
    const loader = document.createElement('div');
    loader.id = 'cart-loader';
    loader.style.display = 'none';
    loader.style.marginTop = '15px'; // space below button
    loader.style.textAlign = 'center'; // center message
    loader.style.fontWeight = 'normal'; // not bold
    loader.style.color = 'green'; // green text
    loader.innerHTML = '⏳ Adding to cart...';

    // Insert after the button
    addToCartBtn.parentNode.appendChild(loader);

    if (addToCartBtn && productForm) {
        addToCartBtn.addEventListener('click', function(e) {
            e.preventDefault(); // Prevent page redirect

            const formData = new FormData(productForm);

            // Show loader and disable button
            loader.style.display = 'block';
            addToCartBtn.disabled = true;

            fetch('/cart/add.js', {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'application/json'
                }
            })
            .then(response => response.json())
            .then(data => {
                console.log('Added to cart:', data);
                loader.textContent = '✅ Product added!';
                setTimeout(() => { loader.style.display = 'none'; }, 2000);
            })
            .catch(error => {
                console.error('Error adding to cart:', error);
                loader.textContent = '❌ Failed to add to cart';
                setTimeout(() => { loader.style.display = 'none'; }, 2000);
            })
            .finally(() => {
                addToCartBtn.disabled = false;
            });
        });
    }
});








document.addEventListener('DOMContentLoaded', function() {
  var header = document.querySelector('.header_navbar'); // adjust selector as needed

  window.addEventListener('scroll', function() {
    if (window.scrollY > 50) { // trigger point in pixels
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });
});



